import { jsx as _jsx } from "react/jsx-runtime";
import { Turnstile } from '@marsidev/react-turnstile';
import * as React from 'react';
export const Captcha = ({ onChange, siteKey })=>/*#__PURE__*/ _jsx(Turnstile, {
        siteKey: siteKey,
        onSuccess: (token)=>{
            onChange == null ? void 0 : onChange(token);
        }
    });
export default Captcha;
